<template>
    <div class="grid-wrapper collection-header">
        <div class="collection-header__hero">
            <picture>
                <source :srcset="collection.product_mobile_image_url" media="(max-width: 992px)">
                <img class="collection-header__image"
                     :src="collection.product_image_url"
                     :alt="collection.product_image_alternative_text" />
            </picture>
        </div>

        <div class="collection-header__content">
            <h1 class="collection-header__title">{{ collection.product_title }}</h1>
            <p class="collection-header__description">
                {{ collection.product_description }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        collection: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.collection-header {
    display: grid;
    gap: 16px;
    grid-template-columns: 1.5fr 1fr;
    margin-top: 0.75rem;
    margin-bottom: 1.5rem;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
        grid-template-rows: auto auto;

        &__hero {
            grid-row-start: -1;
        }
    }

    &__image {
        height: auto;
        max-width: 100%;
        width: 100%;
        object-fit: cover;
    }

    &__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-grow: 1;
        padding: 2rem;
        border: 1px solid #CCCCCC;
    }

    &__title {
        text-align: center;
    }

    &__description {
        font-family: OpenSans;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
    }
}
</style>

